import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('Ticker')

/** 👇 Users View Ticker */
const ViewTicker = ({ tickerType = '' }) => analytics({
  label: GenerateLabel({ label: 'ticker', tickerType }),
  action: 'ticker - view',
  name: 'view_ticker',
});

/** 👇 Users Click Tutup */
const ClickClose = ({ tickerType = '' }) => analytics({
  label: GenerateLabel({ label: 'ticker', tickerType }),
  action: 'ticker - click tutup',
  name: 'click_close',
});

/** 👇 Users Click CTA */
const ClickCta = ({ tickerType = '' }) => analytics({
  label: GenerateLabel({ label: 'ticker', tickerType }),
  action: 'ticker - click CTA',
  name: 'click_cta',
});

const Ticker = { ViewTicker, ClickClose, ClickCta };

export default Ticker;
